// extracted by mini-css-extract-plugin
module.exports = {"Drawer":"cookie-drawer_Drawer___1VPJ","DrawerInner":"cookie-drawer_DrawerInner__B5uBK","open":"cookie-drawer_open__RwBBr","Link":"cookie-drawer_Link__NJWUd"};